/**
 * Created by Ning Jiang on 10/10/2016.
 */


interface MultiStyleTextConfig {
    texts: { text: string, style: any }[],
    wordWrap?: boolean,
    wordWrapWidth?: number
}

export class MultiStyleText extends PIXI.Container {

    private _wordFields: PIXI.Text[];
    private _lineContainers: PIXI.Container[];

    constructor(config: MultiStyleTextConfig) {
        super();
        this._texts = config.texts;
        this._wordWrap = config.wordWrap ? config.wordWrap : false;
        this._wordWrapWidth = config.wordWrapWidth ? config.wordWrapWidth : 100;
        this._wordFields = [];
        this._lineContainers = [];
        this.updateDisplay();
    }

    private _texts: { text: string, style: any }[];

    get texts(): { text: string, style: any }[] {
        return this._texts;
    }

    set texts(value: { text: string, style: any }[]) {
        this._texts = value;
        this.updateDisplay();
    }

    private _wordWrap: boolean;

    get wordWrap(): boolean {
        return this._wordWrap;
    }

    set wordWrap(value: boolean) {
        if (value === this._wordWrap) {
            return;
        }
        this._wordWrap = value;
        this.updateDisplay();
    }

    private _wordWrapWidth: number;

    get wordWrapWidth(): number {
        return this._wordWrapWidth;
    }

    set wordWrapWidth(value: number) {
        if (value === this._wordWrapWidth) {
            return;
        }
        this._wordWrapWidth = value;
        this.updateDisplay();
    }

    private _actualWidth: number;

    get actualWidth(): number {
        return this._actualWidth;
    }

    private _actualHeight: number;

    get actualHeight(): number {
        return this._actualHeight;
    }

    public updateDisplay(): void {
        this._actualWidth = 0;
        this._actualHeight = 0;

        let wordIndex: number = 0;
        let lineIndex: number = 0;
        let offsetX: number = 0;
        let testOffsetX: number = 0;
        let offsetY: number = 0;
        let lineHeight: number = 0;
        let words: string[];
        let word: PIXI.Text;
        let line: PIXI.Container;

        this.clearAll();

        // NOTE: This calculation is not tested when changing texts!!!
        for (let i = 0; i < this._texts.length; i++) {
            words = this._texts[i].text.split(" ");
            for (let j = 0; j < words.length; j++) {
                if (!this._wordFields[wordIndex]) {
                    this._wordFields.push(new PIXI.Text(''));
                }
                word = this._wordFields[wordIndex];
                word.text = words[j];
                word.style = this._texts[i].style;
                testOffsetX = offsetX + word.width;
                if (this._wordWrap && testOffsetX > this._wordWrapWidth) {
                    // Start new line
                    offsetX = 0;
                    offsetY += lineHeight;
                    lineHeight = 0;
                    lineIndex++;
                }
                word.x = offsetX;
                word.y = 0;
                if (j < words.length - 1) {
                    word.text = words[j] + " ";
                }
                offsetX += word.width;
                this._actualWidth = Math.max(this._actualWidth, offsetX);
                lineHeight = Math.max(lineHeight, word.height);
                this._actualHeight = offsetY + lineHeight;

                if (!this._lineContainers[lineIndex]) {
                    this._lineContainers.push(new PIXI.Container());
                }
                line = this._lineContainers[lineIndex];
                line.addChild(word);
                line.y = offsetY;
                if (!line.parent) {
                    this.addChild(line);
                }
                wordIndex++;
            }
        }
    }

    private clearAll(): void {
        for (let i = 0; i < this._lineContainers.length; i++) {
            if (this._lineContainers[i].children.length > 0) {
                this._lineContainers[i].removeChildren(0);
            }
        }
        this.removeChildren(0);
    }
}